import { httpGet, httpPost } from '../../../../../utils/api.utils';
import { CIRCUIT_CATEGORIES as CircuitCategory, EQUIPMENT_TYPE as EquipmentType } from '../../../../../utils/constant.utils';
import { getRequestUserSessionData as getUserData } from '../../../../../utils/helpers.utils';
import { updatePlanTypes, getVendorDetails, getAddresses } from '../../order-request.functions';
import { BUSINESS_CASE } from '../../../../../constants/external-constants';
import { convertToDecimal } from '../../../../../utils/helpers.utils';

import { actions } from 'react-redux-form';

import {
    locationModelA
    , subscriptionModelA
    , businessModelA

    //ACTIONS
    , setUserLocation
    , setCountryOptions
    , setAddressOptions
    , setPlanOptions
    , setVendorOptions
    , setSimOptions
    , setVendorDetails
    , setServiceTypeDetails
    , setDeviceOptions
    , setOrderOptions
    , setCircuitTypes
    , setDeviceAccessories
    , setPrimaryPlanDetails
    , setPurposeOfUseOptions
    , setBusinessCaseOptions
    , setShowDeviceOptions
    , setShowOtherAddress
    , setEmployeeEquipmentProductNames
    , setEmployeeEquipmentOnprogressProductNames
    , setFormSubmitted
} from './../../../../../constants/model-reducers/external/request/wireless-request/new-mobile-subscription.settings';

export const locationModelAInitialState = locationModelA;
export const subscriptionModelAInitialState = subscriptionModelA;
export const businessModelAInitialState = businessModelA;

const planDetailConst = {
    PlanId: 0
    , ComponentName: ''
    , ComponentCost: 0
    , ComponentDetails: ''
    , IsPrimary: true
}

const serviceTypeDetailConst = {
    EquipmentInventoryId: 0
    , OrderCost: 0
}

const defaultState = () => ({
    userLocation: {}
    , countryOptions: []
    , addressOptions: []
    , simOptions: []
    , preferredVendorOptions: []
    , nonPrefVendorOptions: []
    , planOptions: []
    , orderOptions: []
    , circuitTypes: []
    , deviceOptions: []
    , deviceAccessories: []
    , vendorDetails: {
        Currency: ''
    }
    , serviceTypeDetail: { ...serviceTypeDetailConst }
    , primaryPlanDetail: { ...planDetailConst }
    , purposeOfUseOptions: []
    , businessCaseOptions: []
    , employeeEquipmentProductNames: []
    , employeeEquipmentOnprogressProductNames: []
    , showDeviceOptions: false
    , showOtherAddress: false
    , formSubmitted: false
    , isAmending: false
});

const initialState = defaultState();

export const newMobileSubscriptionActions = {

    getNewMobileFormData: () => async (dispatch, state) => {

        const { requestTypeId, requestOnBehalfData, isRequestOnBehalfToggle } = state().createRequest;
        const { requestData, isAmending } = state().requestDetail;
       
        var robData = {
            "userId": sessionStorage.UserID,
            "employeeID": requestOnBehalfData.EmployeeId,           
            "enterpriseId": requestOnBehalfData.Eid,           
            "requestInBehalfId": null
        }

        var data = {
            RequestTypeId: requestTypeId
            , OrderId: isAmending ? requestData.Order.OrderId : 0
            , User: requestOnBehalfData.EmployeeId ? { ...robData } : { ...getUserData() }
        };

        var res = await httpPost('external/orderRequest/getOrderForm', data);
        
        if (res != null) {
            dispatch({ type: setUserLocation, data: res.UserLocation });
            dispatch({ type: setCountryOptions, data: res.Countries });
            dispatch({ type: setPurposeOfUseOptions, data: res.PurposeOfUse });
            dispatch({ type: setBusinessCaseOptions, data: res.BusinessJustification });
            dispatch({ type: setShowOtherAddress, data: res.ShowOtherAddress });
            dispatch({ type: setEmployeeEquipmentProductNames, data: res.EmployeeEquipmentProductNames });
            dispatch({ type: setEmployeeEquipmentOnprogressProductNames, data: res.EmployeeEquipmentProductNamesOnProgressOrders });

            dispatch(actions.change('wirelessLocationFormA.country', res.UserLocation.CountryName));
            dispatch(actions.change('wirelessLocationFormA.countryCode', res.UserLocation.CountryCode));
            getAddresses(dispatch, setAddressOptions, res.UserLocation.CountryCode, res.ShowOtherAddress);
            if (isAmending) {
                var userData = getUserData();
                if (requestData.Order.IsRequestedInBehalf) {
                    userData.employeeID = requestData.RequestedInBeHalfOf.EmployeeId;
                }

                dispatch(actions.change('wirelessLocationFormA.isAmending', isAmending));
                if (requestData.BillingAddress.IsOtherLocation === true) {
                    dispatch(actions.change('wirelessLocationFormA.otherDeliveryAddressId', requestData.BillingAddress.OtherDeliveryAddressId));
                    dispatch(actions.change('wirelessLocationFormA.otherDeliveryAddress', requestData.BillingAddress.OtherDeliveryAddress));
                    dispatch(actions.change('wirelessLocationFormA.locationId', requestData.BillingAddress.LocationId));
                    dispatch(actions.change('wirelessLocationFormA.deliveryAddress', requestData.BillingAddress.DeliveryAddress))
                }
                else {
                    dispatch(actions.change('wirelessLocationFormA.deliveryAddress', requestData.BillingAddress.DeliveryAddress));
                    dispatch(actions.change('wirelessLocationFormA.locationId', requestData.BillingAddress.LocationId));
                }

                if (isRequestOnBehalfToggle) {
                    return;
                } 
                
                dispatch(actions.change('wirelessSubscriptionFormA.vendorDetailId', requestData.Subscription.VendorDetailId));
                dispatch(actions.change('wirelessSubscriptionFormA.circuitTypeId', requestData.Subscription.CircuitTypeId));
                updatePlanTypes(dispatch, setPlanOptions, requestData.Subscription.VendorDetailId, requestData.Subscription.CircuitTypeId);
                dispatch(actions.change('wirelessSubscriptionFormA.mobileServiceModel', requestData.Subscription.MobileServiceModel));
                dispatch(actions.change('wirelessSubscriptionFormA.equipmentCatalogId', requestData.Subscription.EquipmentCatalogId));
                dispatch(actions.change('wirelessSubscriptionFormA.mobileServiceModel[0].EquipmentProductName', requestData.Subscription.EquipmentProductName));
                dispatch(actions.change('wirelessSubscriptionFormA.mobileServiceModel[0].EquipmentTypeId', requestData.Subscription.MobileServiceModel[0].EquipmentTypeId));
                dispatch(actions.change('wirelessSubscriptionFormA.equipmentInventoryId', requestData.Subscription.EquipmentCatalogId));
                dispatch(actions.change('wirelessSubscriptionFormA.phoneCaseAccessory', requestData.Subscription.PhoneCaseAccessory));
                dispatch(actions.change('wirelessSubscriptionFormA.planId', requestData.Subscription.PlanId));
                dispatch(actions.change('wirelessBusinessFormA.purposeOfUseId', requestData.BusinessJustification.PurposeOfUseId));
                dispatch(actions.change('wirelessBusinessFormA.busJustiCodeDetailId', requestData.BusinessJustification.BusJustiCodeDetailId));
                dispatch(actions.change('wirelessBusinessFormA.businessJustification', requestData.BusinessJustification.BusinessJustification));
                dispatch(actions.change('wirelessBusinessFormA.additionalInformation', requestData.BusinessJustification.AdditionalInformation));
                dispatch(actions.change('wirelessBusinessFormA.termAgreement', requestData.BusinessJustification.TermAgreement));
                getMobileServiceTypeOptions(dispatch, requestData.Subscription.VendorDetailId, requestData.Subscription.CircuitTypeId, userData.employeeID);
                updatePlanDetails(dispatch, requestData.Subscription.PlanDetails.PlanId);
                dispatch({ type: setPrimaryPlanDetails, data: requestData.Subscription.PlanDetails.planDetailsModel }); 
                dispatch(actions.change('wirelessSubscriptionFormA.mobileServiceModel[0].DiscountedOrderCost', requestData.Subscription.DiscountedOrderCost));
                getOrderMobileDetailList(dispatch, requestData.Order.OrderId);
            }
        }
    }
    , setRequestorAddress: () => (dispatch, state) => {

        const { showOtherAddress, userLocation } = state().newMobileRequest;
        const { requestOnBehalfData } = state().createRequest;

        var location = {
            ...userLocation
        };

        if (requestOnBehalfData.EmployeeId > 0) {
            location = {
                ...requestOnBehalfData.LocationModel
            };
        }

        getAddresses(dispatch, setAddressOptions, userLocation.CountryCode, showOtherAddress);

        dispatch(actions.change('wirelessLocationFormA.country', location.CountryName));
        dispatch(actions.change('wirelessLocationFormA.countryCode', location.CountryCode));
        dispatch(actions.change('wirelessLocationFormA.locationId', location.LocationId));
        dispatch(actions.change('wirelessLocationFormA.deliveryAddress', location.DeliveryAddress));
        dispatch(actions.change('wirelessLocationFormA.otherDeliveryAddress', ''));

    }
    , onAddressSelect: (model, value) => (dispatch, state) => {

        const { addressOptions } = state().newMobileRequest;

        dispatch(actions.change(model, value));

        if (model == 'wirelessLocationFormA.locationId') {
            const deliveryAddress = addressOptions.length > 0 ? addressOptions.find(r => r.Key == value).Value : '';
            dispatch(actions.change('wirelessLocationFormA.deliveryAddress', deliveryAddress));
            dispatch(actions.change('wirelessLocationFormA.otherDeliveryAddress', ''));
            dispatch(actions.change('wirelessLocationFormA.updatedLocationId', value));
        }

    }
    , onCountrySelect: (model, value) => (dispatch, state) => {
        const { countryOptions, showOtherAddress } = state().newMobileRequest;

        dispatch(actions.change(model, value));

        let country = countryOptions.find(o => o['Key'] === value).Value;
        dispatch(actions.change('wirelessLocationFormA.country', country));

        dispatch(actions.change('wirelessLocationFormA.locationId', ''));
        dispatch(actions.change('wirelessLocationFormA.deliveryAddress', ''));
        dispatch(actions.change('wirelessLocationFormA.otherDeliveryAddress', ''))
        resetSubscriptionForm(dispatch);

        getAddresses(dispatch, setAddressOptions, value, showOtherAddress);

    }
    , onVendorSelect: (model, value) => (dispatch, state) => {
        const { wirelessSubscriptionFormA } = state().form;
        dispatch(actions.change(model, value));
        dispatch(actions.change('wirelessSubscriptionFormA.circuitTypeId', 0));
        dispatch(actions.change('wirelessSubscriptionFormA.equipmentCatalogId', 0));
        dispatch(actions.change('wirelessSubscriptionFormA.mobileServiceModel', []));
        dispatch(actions.change('wirelessSubscriptionFormA.accessoryDetailsModel', []));
        dispatch(actions.change('wirelessSubscriptionFormA.planId', 0));
        dispatch(actions.change('wirelessSubscriptionFormA.planDetailsModel', []));
        dispatch(actions.change('wirelessSubscriptionFormA.phoneCaseAccessory', false));
        dispatch({ type: setDeviceAccessories, data: [] });
        dispatch({ type: setShowDeviceOptions, data: false });
        dispatch({ type: setPrimaryPlanDetails, data: planDetailConst });
        getVendorDetails(dispatch, setVendorDetails, defaultState.vendorDetails, value)
        dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });

    }
    , onCircuitTypeSelect: (circuitTypeId) => async (dispatch, state) => {
        const { isRequestOnBehalf, requestOnBehalfData } = state().createRequest;
        const { requestData, isAmending } = state().requestDetail;

        var userData = getUserData();
        if (isAmending) {
            if (requestData.Order.IsRequestedInBehalf) {
                userData.employeeID = requestData.RequestedInBeHalfOf.EmployeeId;
            }
        }
        else {
            if (isRequestOnBehalf) {
                userData.employeeID = requestOnBehalfData.EmployeeId;
            }
        }

        const { wirelessSubscriptionFormA } = state().form;
        dispatch(actions.setErrors('wirelessSubscriptionFormA.equipmentInventoryId', false));
        getMobileServiceTypeOptions(dispatch, wirelessSubscriptionFormA.vendorDetailId, circuitTypeId, userData.employeeID);
        dispatch(actions.change('wirelessSubscriptionFormA.equipmentCatalogId', 0));
        dispatch(actions.change('wirelessSubscriptionFormA.accessoryDetailsModel', []));
        dispatch(actions.change('wirelessSubscriptionFormA.mobileServiceModel', []));
        dispatch(actions.change('wirelessSubscriptionFormA.planId', 0));
        dispatch(actions.change('wirelessSubscriptionFormA.planDetailsModel', []));
        dispatch(actions.change('primaryPlanDetail.ComponentCost', 0));
        dispatch(actions.change('wirelessSubscriptionFormA.phoneCaseAccessory', false));
        dispatch({ type: setPrimaryPlanDetails, data: planDetailConst });
        updatePlanTypes(dispatch, setPlanOptions, wirelessSubscriptionFormA.vendorDetailId, circuitTypeId);
    }
    , onServiceTypeSelect: (model, value) => (dispatch, state) => {
        dispatch(actions.change(model, value));
        dispatch(actions.change('wirelessSubscriptionFormA.mobileServiceModel', []));
        dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });
        getServiceTypeDetails(dispatch, state, value);
        dispatch(actions.change('wirelessSubscriptionFormA.planId', 0));
        dispatch(actions.change('wirelessSubscriptionFormA.planDetailsModel', []));
        dispatch(actions.change('primaryPlanDetail.ComponentCost', 0));
        dispatch(actions.change('wirelessSubscriptionFormA.phoneCaseAccessory', false));
        dispatch({ type: setPrimaryPlanDetails, data: planDetailConst });
        dispatch(actions.change('wirelessSubscriptionFormA.mobileDetailsModel', subscriptionModelA.mobileDetailsModel));
        getmobileDetailList(dispatch, value);
    }
    , onPlanSelect: (model, value) => (dispatch, state) => {
        dispatch(actions.change(model, value));
        dispatch(actions.change('wirelessSubscriptionFormA.planDetailsModel', subscriptionModelA.planDetailsModel));
        dispatch({ type: setPrimaryPlanDetails, data: planDetailConst });
        updatePlanDetails(dispatch, value);

    }
    , onAccessorySelect: (e) => async (dispatch, state) => {

        const { deviceAccessories } = state().newMobileRequest;
        const { wirelessSubscriptionFormA } = state().form;
        var selectedObj = deviceAccessories.find(x => x.EquipmentInventoryId == e.target.value);
        var newAccessories = [...wirelessSubscriptionFormA.accessoryDetailsModel];

        if (e.target.checked) {
            newAccessories.push(selectedObj);
        } else {

            const indexOfObject = wirelessSubscriptionFormA.accessoryDetailsModel.findIndex(o => {
                return o.EquipmentInventoryId == e.target.value;
            });

            newAccessories.splice(indexOfObject, 1);
        }

        dispatch(actions.change('wirelessSubscriptionFormA.accessoryDetailsModel', newAccessories));
    }
    , onSubscriptionFormLoad: () => async (dispatch, state) => {
        const { wirelessLocationFormA, wirelessSubscriptionFormA } = state().form;
        const { isAmending } = state().requestDetail;

        if (wirelessSubscriptionFormA.vendorDetailId !== '' && isAmending !== true) return;

        if (wirelessSubscriptionFormA.vendorDetailId !== '') {
            getVendorDetails(dispatch, setVendorDetails, defaultState.vendorDetails, wirelessSubscriptionFormA.vendorDetailId);
        }

        var data = {
            ...wirelessLocationFormA
        };

        var res = await httpPost('external/orderRequest/getVendors', data);
        if (res.ok == undefined && res.PrefVendors.length > 0) {
            dispatch({
                type: setVendorOptions
                , prefVendors: res.PrefVendors
                , nonPrefVendors: res.NonPrefVendors
            });
            if (res.PrefVendors[0].Key != 0) {
                var prefVendorsKey;
                if (isAmending === true) {
                    prefVendorsKey = wirelessSubscriptionFormA.vendorDetailId;
                }
                else {
                    prefVendorsKey = res.PrefVendors.length == 1 ? res.PrefVendors[0].Key : 0;
                }
                dispatch(actions.change('wirelessSubscriptionFormA.vendorDetailId', prefVendorsKey));
                getCircuitTypes(dispatch, CircuitCategory.mobile);
            }
        }
    }
    , onBussinessCaseSelect: (model, value) => async (dispatch, state) => {
        const { businessCaseOptions } = state().newMobileRequest;
        dispatch(actions.change(model, value));

        const textValue = businessCaseOptions.length > 0 ? businessCaseOptions.find(r => r.Key == value).Value : '';
        if (value == BUSINESS_CASE.other) {
            dispatch(actions.change('wirelessBusinessFormA.businessJustification', ''));
        } else {
            dispatch(actions.change('wirelessBusinessFormA.businessJustification', textValue));
        }
    }
    , resetNewMobileForm: () => (dispatch, state) => {
        resetNewMobileForm(dispatch);
    }
    , submitRequest: () => async (dispatch, state) => {

        const { requestTypeId, isRequestOnBehalf, requestOnBehalfData } = state().createRequest;
        const { wirelessLocationFormA, wirelessSubscriptionFormA, wirelessBusinessFormA } = state().form;
        const { requestData, isAmending } = state().requestDetail;
        
        var planComponents = wirelessSubscriptionFormA.planDetailsModel.length > 0 ? wirelessSubscriptionFormA.planDetailsModel[0].dataItem : [];

        dispatch(actions.change('wirelessSubscriptionFormA.planDetails.planComponents', planComponents));
        dispatch(actions.change('wirelessLocationFormA.otherDeliveryAddressId', requestData.OtherLocationID ));

        let userData = getUserData();
        const requestorEmployeeID = userData.employeeID

        if (isRequestOnBehalf) {
            userData.requestInBehalfId = requestOnBehalfData.EmployeeId;
            userData.employeeID = requestOnBehalfData.EmployeeId;
        }

        userData.managerApproverId = isRequestOnBehalf ?
            requestOnBehalfData.CostCodeApproverEmployeeId : sessionStorage.CostCodeAuthorizerID;

        var data = {
            SubscriptionModel: { ...state().form.wirelessSubscriptionFormA, EquipmentInventory: wirelessSubscriptionFormA.mobileServiceModel[0].EquipmentModel }
            , BusinessJustificationModel: { ...wirelessBusinessFormA }
            , User: {
                ...userData
            }
            , NoEmail: true
            , RequestTypeId: requestTypeId
            , IsAmending: isAmending
            , OrderId: isAmending ? requestData.Order.OrderId : 0
            , CircuitId: isAmending ? requestData.CircuitId : 0
            , EquipmentInventoryId: isAmending ? requestData.Subscription.EquipmentCatalogId : 0
            , CircuitOrderId: isAmending ? requestData.CircuitOrderId : 0
            , OrderHistoryId: isAmending ? requestData.OrderHistoryId : 0
            , OrderInfoId: isAmending ? requestData.OrderInfoId : 0
            , LocationOrderModel: {
                CountryCode: wirelessLocationFormA.countryCode,
                Country: isRequestOnBehalf ? requestOnBehalfData.LocationModel.CountryName : wirelessLocationFormA.country,
                LocationCountryID: isRequestOnBehalf ? requestOnBehalfData.LocationModel.CountryId : wirelessLocationFormA.locationCountryID,
                LocationId: wirelessLocationFormA.updatedLocationId !== undefined
                    ? wirelessLocationFormA.updatedLocationId
                    : wirelessLocationFormA.locationId,
                OtherDeliveryAddress: wirelessLocationFormA.otherDeliveryAddress,
                DeliveryAddress: wirelessLocationFormA.deliveryAddress,
                OtherLocationID: isAmending ? requestData.otherLocationID : wirelessLocationFormA.otherLocationID
            }
            , RequestorID: Number(requestorEmployeeID)

        };

        dispatch({ type: setFormSubmitted, data: true });
        var res = await httpPost('external/orderRequest', data);

        if (!(res.Success)) {
            dispatch({ type: setFormSubmitted, data: false });
        }

        return res;
    }
}

function resetNewMobileForm(dispatch) {   

    dispatch(actions.reset('wirelessLocationFormA'));
    dispatch(actions.reset('wirelessSubscriptionFormA'));
    dispatch(actions.reset('wirelessBusinessFormA'));
    getCountries(dispatch)
    dispatch({ type: setFormSubmitted, data: false });   
}

async function getCountries(dispatch) {
    var res = await httpPost('external/replaceDevice/getCountriesList');
    if (res != null) {
        dispatch({ type: setCountryOptions, data: res });
        dispatch(actions.change('wirelessLocationFormA.country', res[0].Value));
        dispatch(actions.change('wirelessLocationFormA.countryCode', res[0].Key));
    } else {
        dispatch({ type: setCountryOptions, data: { ...defaultState.countryOptions } });
    }
}

function resetSubscriptionForm(dispatch) {
    dispatch(actions.reset('wirelessSubscriptionFormA'));
    dispatch({ type: setPlanOptions, data: [] });
    dispatch({ type: setVendorOptions, data: [] });
    dispatch({ type: setSimOptions, data: [] });
    dispatch({ type: setPrimaryPlanDetails, data: planDetailConst });
}

async function getDeviceAccessories(dispatch, vendorId) {

    var res = await httpGet('external/orderRequest/getEquipmentData/' + vendorId + '/' + EquipmentType.Accessory);

    if (res != null && res.length > 0) {
        dispatch({ type: setDeviceAccessories, data: res });
    } else {
        dispatch({ type: setDeviceAccessories, data: [] });
    }
}

async function getServiceTypeDetails(dispatch, state, typeId) {

    var res = await httpGet('external/orderRequest/getMobileServiceTypeDetails/' + typeId);

    if (res != null && res.length > 0) {
        dispatch({ type: setServiceTypeDetails, data: res[0] });
        dispatch(actions.change('wirelessSubscriptionFormA.mobileServiceModel', res));

        const { isAmending } = state().requestDetail;
        if (isAmending) {
            const { employeeEquipmentProductNames, employeeEquipmentOnprogressProductNames } = state().newMobileRequest;
            const { wirelessSubscriptionFormA } = state().form;
            const termAgreement = (employeeEquipmentProductNames.includes(wirelessSubscriptionFormA.mobileServiceModel[0].EquipmentProductName.value) || employeeEquipmentOnprogressProductNames.includes(wirelessSubscriptionFormA.mobileServiceModel[0].EquipmentProductName.value))
                && (wirelessSubscriptionFormA.mobileServiceModel[0].EquipmentTypeId.value === EquipmentType.Device);

            dispatch(actions.change('wirelessBusinessFormA.termAgreement', termAgreement ? true : false));
        }  

    } else {
        dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });
        dispatch(actions.change('wirelessSubscriptionFormA.mobileServiceModel', []));
    }

}

async function getmobileDetailList(dispatch, typeId) {
    var res = await httpGet('external/orderRequest/getMobileDetailList/' + typeId);

    if (res.datatable.length > 0 && res.datatable[0].dataItem.length > 0) {
        if(res.datatable[0].dataItem[0].DiscountedOrderCost !== undefined){
            res.datatable[0].dataItem[0].DiscountedOrderCost = convertToDecimal(res.datatable[0].dataItem[0].DiscountedOrderCost);
        }
        var data = res.datatable;
        dispatch(actions.change('wirelessSubscriptionFormA.mobileDetailsModel', data));
    }
    return res != null;
}

async function getOrderMobileDetailList(dispatch, orderId) {
    var res = await httpGet('external/orderRequest/getOrderMobileDetailList/' + orderId);

    if (res.datatable.length > 0 && res.datatable[0].dataItem.length > 0) {
        if(res.datatable[0].dataItem[0].DiscountedOrderCost !== undefined){
            res.datatable[0].dataItem[0].DiscountedOrderCost = convertToDecimal(res.datatable[0].dataItem[0].DiscountedOrderCost);
        }
        var data = res.datatable;
        dispatch(actions.change('wirelessSubscriptionFormA.mobileDetailsModel', data));
    }
    return res != null;
}

async function updatePlanDetails(dispatch, id) {
    var res = await httpGet('external/orderRequest/getOrderPlanComponentByPlan/' + id);

    if (res.datatable.length > 0 && res.datatable[0].dataItem.length > 0) {
        var data = res.datatable;

        dispatch(actions.change('wirelessSubscriptionFormA.planDetailsModel', data));

        var primaryPlan = Object.keys(data[0].dataItem)
            .map((key) => data[0].dataItem[key])
            .filter((item) => item.IsPrimary === true);

        if (primaryPlan != null && primaryPlan.length > 0) {
            dispatch({
                type: setPrimaryPlanDetails,
                data: primaryPlan[0]
            });
        }
    }
    return res != null;
}


async function getSimTypes(dispatch) {
    var res = await httpPost('external/orderRequest/getSimTypes');
    if (res != null) {
        dispatch({ type: setSimOptions, data: res });
    }
    return res != null && res.ok !== false;
}

async function getCircuitTypes(dispatch, id) {
    var res = await httpGet('external/orderRequest/getCircuitTypesByCategoryId/' + id);
    if (res != null) {
        dispatch({ type: setCircuitTypes, data: res });
    } else {
        dispatch({ type: setCircuitTypes, data: defaultState.circuitTypes });
    }
}

async function getMobileServiceTypeOptions(dispatch, vendorId, circuitTypeId, employeeId) {

    var res = await httpGet('external/orderRequest/getAllMobileServiceTypes/' + vendorId + '/' + circuitTypeId + '/' + employeeId);
    if (res != null) {
        dispatch({ type: setDeviceOptions, data: res });
    }
    else {
        dispatch({ type: setDeviceOptions, data: defaultState.deviceOptions });
    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setUserLocation:
            return {
                ...state,
                userLocation: action.data
            };
        case setCountryOptions:
            return {
                ...state,
                countryOptions: action.data
            };
        case setAddressOptions:
            return {
                ...state,
                addressOptions: action.data
            };
        case setSimOptions:
            return {
                ...state,
                simOptions: action.data
            };
        case setVendorOptions:
            return {
                ...state,
                preferredVendorOptions: action.prefVendors
                , nonPrefVendorOptions: action.nonPrefVendors
            };
        case setPlanOptions:
            return {
                ...state,
                planOptions: action.data
            };
        case setOrderOptions:
            return {
                ...state,
                orderOptions: action.data
            };
        case setCircuitTypes:
            return {
                ...state,
                circuitTypes: action.data
            };
        case setDeviceOptions:
            return {
                ...state,
                deviceOptions: action.data
            };
        case setDeviceAccessories:
            return {
                ...state,
                deviceAccessories: action.data
            };
        case setVendorDetails:
            return {
                ...state,
                vendorDetails: action.data
            };
        case setServiceTypeDetails:
            return {
                ...state,
                serviceTypeDetail: action.data
            };
        case setPrimaryPlanDetails:
            return {
                ...state,
                primaryPlanDetail: action.data
            };
        case setPurposeOfUseOptions:
            return {
                ...state,
                purposeOfUseOptions: action.data
            };
        case setBusinessCaseOptions:
            return {
                ...state,
                businessCaseOptions: action.data
            };
        case setShowDeviceOptions:
            return {
                ...state,
                showDeviceOptions: action.data
            };
        case setShowOtherAddress:
            return {
                ...state,
                showOtherAddress: action.data
            };
        case setEmployeeEquipmentProductNames:
            return {
                ...state,
                employeeEquipmentProductNames: action.data
            };
        case setEmployeeEquipmentOnprogressProductNames:
            return {
                ...state,
                employeeEquipmentOnprogressProductNames: action.data
            };
        case setFormSubmitted:
            return {
                ...state,
                formSubmitted: action.data
            };
        default: return state;
    }
}